import React from "react";
import { Routes, Route } from "react-router-dom";

import LandingPage   from "./LandingPage";
import AdminPage     from "./pages/AdminPage";
import WallboardPage from "./pages/WallboardPage";

export default function App() {
  return (
    <Routes>
      <Route path="/"      element={<LandingPage />}   />
      <Route path="/admin" element={<AdminPage />}     />
      <Route path="/:slug" element={<WallboardPage />} />
    </Routes>
  );
}
